export { default } from "./ConnectWallet-component";
